<template>
  <div>
    <b-form>
      <b-form-group id="exampleInputGroup1" label="Site Alias" label-for="wp_alias" description="Enter a custom name to display instead of the website domain name.
Leave blank to display domain name.">
        <b-form-input id="wp_alias" type="text" v-model="value.name" required placeholder="Enter name" @input="updateData">
        </b-form-input>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'sitealias',
  props: ['value'],
  methods: {
    updateData() {
      this.$emit('input', this.value);
    }
  }
};
</script>

<style>
</style>
